export const loginCaptchaFa = {
  title: 'تأیید امنیتی ورود',
  label: 'کد امنیتی',
  prompt: 'برای ادامه ورود، کد داخل تصویر را وارد کنید.',
  imageAlt: 'تصویر کد امنیتی شش رقمی',
  loading: 'در حال دریافت کد امنیتی…',
  unavailable: 'تصویر آماده نیست',
  refresh: 'تصویر جدید',
  help: 'اعداد فارسی یا انگلیسی مجاز است. اگر خواندن تصویر برایتان ممکن نیست، با مدیر سامانه تماس بگیرید.',
  required: 'کد امنیتی را وارد کنید؛ اگر تصویر ندارید «تصویر جدید» را بزنید.',
  activationRequired: 'برای ادامه ورود، به دلیل تلاش ناموفق قبلی، کد امنیتی تصویر را وارد کنید.',
  loadFailed: 'دریافت کد امنیتی ناموفق بود؛ «تصویر جدید» را بزنید و دوباره تلاش کنید.',
  errors: {
    INVALID_CREDENTIALS: 'نام کاربری یا رمز عبور صحیح نیست.',
    LOGIN_CAPTCHA_REQUIRED: 'کد امنیتی صحیح نیست یا منقضی شده است.',
    ACCOUNT_DISABLED: 'حساب غیرفعال است؛ با مدیر سامانه تماس بگیرید.',
    ACCOUNT_LOCKED: 'حساب موقتاً قفل شده است؛ کمی بعد دوباره تلاش کنید.',
  } as Record<string, string>,
};
